<script setup>
import { ref, getCurrentInstance } from 'vue';

const props = defineProps({
  loading: Boolean
});
const { proxy } = getCurrentInstance();
const dates = ref(proxy.$constants.MATCH.ALL_DATES);
</script>

<style scoped>
/* .shimmerElement {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
} */
</style>

<template>
  <div class="h-full overflow-hidden">
    <div class="bg-secondary fixed top-0 z-10 w-full">
      <div class="mobile-status-padding"></div>
      <div class="px-4 overflow-x-hidden w-full h-24">
        <div class="flex gap-4 items-center h-full">
          <div class="w-8 h-8 min-w-8 flex items-center justify-center">
            <button class="w-full h-full">
              <ColorImg
                class="w-full h-full bg-white/20"
                alt="Calendar"
              />
            </button>
          </div>
          <div class="h-12 border-l border-white/20"></div>
          <div class="w-full overflow-auto flex gap-6 py-3">
            <div
              v-for="(date, i) in dates"
              :key="i"
              :id="date.id"
              class="flex-shrink-0 cursor-pointer transition-all"
              @click="selectDate(date.id)"
            >
              <div
                class="flex flex-col justify-center items-center p-2 rounded-lg min-w-[60px]"
              >
                <div class="font-bold uppercase shimmerElement rounded-full">
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                </div>
                <div class="uppercase shimmerElement rounded-full">
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                </div>
              </div>
            </div>
          </div>
          <div class="h-12 border-l border-white/20"></div>
           <div class="w-8 h-8 min-w-8 flex items-center justify-center">
            <button class="w-full h-full">
              <ColorImg
                class="w-full h-full bg-white/20"
                alt="Calendar"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-full overflow-auto">
      <div class="">
        <div class="h-[8rem]"></div>
        <div class="flex flex-col">
          <div
            v-for="i in 5"
            :key="`shimmer-${i}`"
            class="scroll-m-[9rem] pb-32"
          >
            <!-- Header shimmer -->
            <div class="sticky top-0 z-[5] flex flex-col items-center mb-4">
              <div class="w-24 h-0.5 shimmerElement rounded-full mb-2"></div>
              <div class="w-48 h-6 shimmerElement rounded-lg mb-2"></div>
              <div class="w-32 h-4 shimmerElement rounded-full"></div>
              <div class="w-24 h-0.5 shimmerElement rounded-full mt-2"></div>
            </div>

            <!-- Matches shimmer blocks -->
            <div class="px-4 space-y-4">
              <!-- Simuler 2-3 cartes de match par jour -->
              <div
                v-for="j in 2"
                :key="`shimmer-match-${i}-${j}`"
                class="rounded-3xl overflow-hidden"
              >
                <div class="p-4 space-y-3">
                  <!-- Header catégorie shimmer -->
                  <div class="flex items-center gap-4">
                    <div class="w-8 h-8 shimmerElement rounded-full"></div>
                    <div class="flex-1 space-y-2">
                      <div class="w-48 h-4 shimmerElement rounded-lg"></div>
                      <div class="w-32 h-3 shimmerElement rounded-full"></div>
                    </div>
                    <div class="w-5 h-5 shimmerElement rounded-full"></div>
                  </div>

                  <!-- Matches shimmer -->
                  <div class="space-y-2 pt-2">
                    <div
                      v-for="k in 2"
                      :key="`shimmer-team-${i}-${j}-${k}`"
                      class="flex items-center gap-3"
                    >
                      <div class="w-12 h-4 shimmerElement rounded-full"></div>
                      <div class="flex-1">
                        <div
                          class="w-24 h-3 shimmerElement rounded-full mb-1"
                        ></div>
                        <div class="w-16 h-3 shimmerElement rounded-full"></div>
                      </div>
                      <div class="w-8 h-4 shimmerElement rounded-full"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
